import React from 'react';
import Markdown from 'react-markdown';

interface MarkdownResultProps {
  content: string;
}

const MarkdownResult: React.FC<MarkdownResultProps> = ({ content }) => {
  return (
    <div className="prose prose-sm max-w-none p-4 prose-invert">
      <Markdown>{content}</Markdown>
    </div>
  );
};

export default MarkdownResult; 



